import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import RubyOutlinedSvg from "@ant-design/icons-svg/es/asn/RubyOutlined";
import AntdIcon from "../components/AntdIcon";
var RubyOutlined = function RubyOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: RubyOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  RubyOutlined.displayName = 'RubyOutlined';
}
export default /*#__PURE__*/React.forwardRef(RubyOutlined);